import UtangPiutang from '@/services/utang_piutang';

export default {
	namespaced: true,
	state: {},

	getters: {
		async getUtang({ commit, state, getters, dispatch }) {
			try {
				const response = await UtangPiutang.getUtangPiutang('UTANG');
				return response.data ? response.data.data : [];
			} catch (e) {
				console.log(e);
			}
    },
    async getPiutang({ commit, state, getters, dispatch }) {
			try {
        const response = await UtangPiutang.getUtangPiutang('PIUTANG');
				return response.data ? response.data.data : [];
			} catch (e) {
				console.log(e);
			}
		}
	},

	actions: {
	},

	mutations: {
	}
};
